import { ShieldX } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Forbidden() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ background: "#FCFAEE" }}
      data-testid="forbidden-page"
    >
      <div className="text-center max-w-md">
        <div
          className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6"
          style={{ background: "#FDE2E2" }}
        >
          <ShieldX size={32} style={{ color: "#B91C1C" }} />
        </div>
        <h1
          className="text-5xl font-bold mb-2"
          style={{ color: "#1A1A1A", fontFamily: "Inter, sans-serif" }}
        >
          403
        </h1>
        <h2
          className="text-lg font-semibold mb-3"
          style={{ color: "#374151" }}
        >
          Acceso denegado
        </h2>
        <p className="text-sm mb-8" style={{ color: "#71644C" }}>
          No tienes permisos para acceder a esta sección.
          Contacta a un administrador si crees que esto es un error.
        </p>
        <button
          onClick={() => navigate("/dashboard")}
          className="px-6 py-2.5 rounded-lg text-sm font-semibold text-white transition-colors"
          style={{ background: "#00628F" }}
          data-testid="forbidden-back-btn"
        >
          Volver al Dashboard
        </button>
      </div>
    </div>
  );
}
